import Handlebars from 'handlebars';
export default (source, target, jsonData) => {
  const template = Handlebars.compile(source);
  target.innerHTML = template(jsonData);
}